import { Box } from '@mui/system';
import React from 'react'
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import { Link, useHistory } from 'react-router-dom';
import styled from 'styled-components';
import alertify from 'alertifyjs';
import axios from 'axios';
import APIModel from '../../Models/APIModel';
const CheckOTP = () => {
    const history = useHistory();
    const [OTP, setOTP] = React.useState('');
    const handleOTP = (e)=>{
        if(e.target.value.length <= 6)
            setOTP(e.target.value);
    }
    const handleClickVerify = (e)=>{
        e.preventDefault();
        let params = {otp: OTP, email: localStorage.getItem('user_email')}
        axios.post(APIModel.HOST + "reset", params,{
            'headers': {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            }
          }).then(res=>{

              if(res.data.status === true){
                    alertify.success("OTP verified");
                    history.push('/reset');
              }
              else
              alertify.error("OTP is Wrong");
          }).catch(err=>alertify.error(err));
    }
    return (
        <>
        <main className="">
          <div className="container-fluid container-login">
            <div className="row justify-content-center align-items-center" style={{ height: '100vh' }}>
              <div className="col-12 col-md-7 col-xl-5">
                <div className="card card-signin my-5">
                    <div div className="card-header card-header-primary">
                      <h4 className="card-title text-center"><b>Verify OTP</b></h4>
                    </div>
                  <div className="card-body">
                  <div className="logo text-center mb-3">
                    <img src={process.env.PUBLIC_URL + '/logo.png'} alt="Logo" className="logo"/>
                  </div>
                    <form onSubmit={handleClickVerify}>
                      <input
                        type="hidden"
                        name="_token"
                        defaultValue="hLuKijK86fLz0Xp4rJoK4Rzxu9jXz25VZF9dJ4mP"
                      />
                      <div className="ro">
                        <div className="col-12">
                      <div className="form-group">
                      <label className="bmd-label-floating">Enter OTP</label>
                          <input
                            id="number"
                            type="number"
                            className="form-control"
                            name="OTP"
                            // placeholder="Enter The OTP"
                            value={OTP}
                            maxLength="6"
                            onChange={handleOTP}
                            autoFocus
                            required
                          />
                      </div>
                        </div>
                      </div>
                    
                    <div className="mt-2">
                      <button type="submit" className="btn btn-primary w-100">
                            Verify OTP
                        </button> 
                    </div>

                    <div class="mt-3">
                      <Link to="/" className="link-colour"><Box fontWeight="fontWeightBold">&#8592; Back To Sign In</Box></Link>
                      </div>

                    
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>

        </>
    );
};

export default CheckOTP;
